document.addEventListener("DOMContentLoaded", function () {
  // === اختَر المدة اللي تحب العداد يبدأ منها (مثلاً: ساعتين من الآن) ===
  const countdownDuration = 2 * 60 * 60 * 1000; // ساعتين بالميلي ثانية

  const targetTime = new Date().getTime() + countdownDuration;

  const hoursEl = document.getElementById("hours");
  const minutesEl = document.getElementById("minutes");
  const secondsEl = document.getElementById("seconds");

  function updateCountdown() {
    const now = new Date().getTime();
    const distance = targetTime - now;

    if (distance <= 0) {
      hoursEl.textContent = "00";
      minutesEl.textContent = "00";
      secondsEl.textContent = "00";
      clearInterval(timer);
      return;
    }

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    hoursEl.textContent = String(hours).padStart(2, '0');
    minutesEl.textContent = String(minutes).padStart(2, '0');
    secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  const timer = setInterval(updateCountdown, 1000);
  updateCountdown();
});
document.addEventListener("DOMContentLoaded", () => {
  // === Offer Cards Logic ===
  const cards = document.querySelectorAll(".offer-card");
  const base = document.getElementById("base-price");
  const discount = document.getElementById("discount");
  const final = document.getElementById("final-price");
  const priceDisplay = document.getElementById("price-display");
  const whatsappBtn = document.getElementById("whatsapp-send");
  const blackBtn = document.getElementById("black-order-btn");
  let selectedOffer = document.querySelector(".offer-card.active input");

  // === Update all displayed prices ===
  function updatePrices(offer) {
    const price = Number(offer.dataset.price);
    const old = Number(offer.dataset.old);
    const disc = Number(offer.dataset.discount);
    base.textContent = `$${old.toFixed(2)}`;
    discount.textContent = `-$${disc.toFixed(2)}`;
    final.textContent = `$${price.toFixed(2)}`;
    if (priceDisplay) priceDisplay.textContent = `$${price.toFixed(2)}`;
  }

  // Initialize prices
  if (selectedOffer) updatePrices(selectedOffer);

  // === Offer selection ===
  cards.forEach(card => {
    card.addEventListener("click", () => {
      cards.forEach(c => c.classList.remove("active"));
      card.classList.add("active");
      selectedOffer = card.querySelector("input");
      selectedOffer.checked = true;
      updatePrices(selectedOffer);
    });
  });

  // === WhatsApp Sender (for both buttons) ===
  function sendToWhatsApp() {
    if (!selectedOffer) return;

    const qty = selectedOffer.dataset.qty;
    const price = selectedOffer.dataset.price;
    const colorSelects = document.querySelectorAll(".offer-card.active select");
    const colors = [...colorSelects].map((s, i) => `لون ${i + 1}: ${s.value}`).join("\n");

    const name = document.getElementById("first-name").value.trim();
    const last = document.getElementById("last-name").value.trim();
    const phone = document.getElementById("phone").value.trim();
    const region = document.getElementById("region").value.trim();
    const address = document.getElementById("address").value.trim();

    if (!name || !last || !phone || !region || !address) {
      alert("يرجى ملء جميع الحقول المطلوبة");
      return;
    }

    const lines = [
      "طلب جديد من موقع AlignMate™",
      "-----------------------------",
      `الاسم: ${name} ${last}`,
      `رقم الهاتف: ${phone}`,
      `المنطقة: ${region}`,
      `العنوان: ${address}`,
      "-----------------------------",
      `العرض المختار: ${qty} وسادة`,
      `السعر الإجمالي: $${price}`,
      "الألوان:",
      colors,
      "-----------------------------",
      "توصيل مجاني داخل لبنان"
    ];

    const encoded = encodeURIComponent(lines.join("\n"));
    const phoneNumber = "96171937577";
    window.open(`https://wa.me/${phoneNumber}?text=${encoded}`, "_blank");
  }

  if (whatsappBtn) whatsappBtn.addEventListener("click", sendToWhatsApp);
  if (blackBtn) blackBtn.addEventListener("click", sendToWhatsApp);

  // === Peek Image Slider (show first + half next) ===
  const track = document.querySelector(".slider-track");
  if (track) {
    const slides = track.querySelectorAll(".slide");

    // Setup scrollable slider
    track.style.display = "flex";
    track.style.overflowX = "auto";
    track.style.scrollSnapType = "x mandatory";
    track.style.scrollBehavior = "smooth";
    track.style.gap = "16px";
    track.style.padding = "10px";
    track.style.webkitOverflowScrolling = "touch";

    slides.forEach(slide => {
      slide.style.flex = "0 0 95%"; // show first + part of next
      slide.style.scrollSnapAlign = "start";
      slide.style.borderRadius = "14px";
      slide.style.overflow = "hidden";
      slide.style.transition = "transform 0.3s ease";
    });

    // Optional hover zoom
    slides.forEach(slide => {
      slide.addEventListener("mouseenter", () => (slide.style.transform = "scale(1.02)"));
      slide.addEventListener("mouseleave", () => (slide.style.transform = "scale(1)"));
    });
  }
});

// === Scroll helper ===
function scrollToOffers() {
  const offerSection = document.querySelector(".order-form-section");
  if (offerSection) {
    offerSection.scrollIntoView({ behavior: "smooth" });
  }
}
// Hide dropdowns until an offer is selected
document.querySelectorAll(".offer-card").forEach(card => {
  const input = card.querySelector("input");
  const body = card.querySelector(".offer-body");

  if (!card.classList.contains("active")) {
    body.style.display = "none";
  }

  card.addEventListener("click", () => {
    document.querySelectorAll(".offer-card").forEach(c => {
      c.classList.remove("active");
      c.querySelector(".offer-body").style.display = "none";
    });
    card.classList.add("active");
    body.style.display = "block";
  });
});